import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { AuthenticationService } from '../_service/authentication.service';
import { GlobalEventsService } from '../_service/globalevents.service';
import { PasswordValidator } from '../_validator/password-validator';

@Component({
    templateUrl: 'register.component.html',
    styleUrls: ['register.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class RegisterComponent implements OnInit {
    registerForm: UntypedFormGroup;
    loading = false;
    error = '';
    submitted = false;

    constructor(
        private router: Router,
        private formBuilder: UntypedFormBuilder,
        private authenticationService: AuthenticationService,
        private globalEventsService: GlobalEventsService) {
    }

    ngOnInit() {
        this.registerForm = this.formBuilder.group({
            firstname: ['', Validators.required],
            lastname: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]],
            password: ['', [Validators.required, PasswordValidator.strongPassword()]]
        });
    }

    // Convenience getter for easy access to form fields
    get f() { return this.registerForm.controls; }

    register() {
        this.submitted = true;

        // Stop if form is invalid
        if (this.registerForm.invalid) {
            return;
        }

        this.loading = true;
        this.authenticationService.register(
            this.f.email.value,
            this.f.password.value,
            this.f.firstname.value,
            this.f.lastname.value
        )
            .subscribe(
                result => {
                    if (result === true) {
                        this.globalEventsService.showIsLoggedIn(true);
                        this.router.navigate(['/']);
                    } else {
                        this.error = 'Registration failed. Please try again.';
                        this.loading = false;
                    }
                },
                error => {
                    // Handle API errors, including password complexity errors
                    if (error && error.error && error.error.message) {
                        this.error = error.error.message;
                    } else {
                        this.error = 'Registration failed. Please check your information and try again.';
                    }
                    this.loading = false;
                }
            );
    }
}
